import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ReportDisclosureIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M3.88 1.88A3 3 0 0 1 6 1h8.5a1 1 0 0 1 .7.3l5.5 5.5a1 1 0 0 1 .3.7V20a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 .88-2.12ZM6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.91L14.09 3H6Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M14 1a1 1 0 0 1 1 1v5h5a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1Zm1.7 11.3a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4 0l-2-2a1 1 0 1 1 1.4-1.4l1.3 1.29 3.3-3.3a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default ReportDisclosureIcon;
